import api from '../../plugins/api';

// POST /api/crm/onboarding — сохранить пройденное. Можно слать только то,
// что изменилось: остальные поля на сервере останутся как были.
const saveOnboarding = ({ tourSeen, checklist, checklistHidden }) => {
  return api.post('/api/crm/onboarding', { tourSeen, checklist, checklistHidden });
};

export default saveOnboarding;
